import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Checkbox, Input, Select, Button, Divider, TreeSelect, Tooltip } from 'antd';
import { FacebookOutlined, InstagramOutlined, ChromeOutlined, QuestionCircleOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import Icon from '@ant-design/icons';
import './styles.css';
import LocationMap from '../../containers/GoogleMaps/LocationMap';

const { Option } = Select;
const { TreeNode } = TreeSelect;

const FormProfileResto = ({ onSubmit, restaurant, countriesOptions, provincesOptions, onCountrySelected, citiesOptions, onProvinceSelected, citySelected, provinceSelected, countrySelected, onCitySelected, places, styles, types, services, isSaving, onExit, rangePrice, lat, lng, onLatChange, onLngChange }) => {
    
    const [form] = Form.useForm();

    const getCountrySelected = () => {
        var country = undefined;
        if(restaurant.address && restaurant.address.country && places && places[restaurant.address.country]) {
            country = restaurant.address.country;
        }
        return country;
    }

    const getProvinceSelected = () => {
        var provinceSelected = undefined;
        if(restaurant.address && restaurant.address.country && places && places[restaurant.address.country]) {
            places[restaurant.address.country]['provinces'].forEach(province => {
                if(province && province.name && province.name === restaurant.address.province) {
                    provinceSelected = province.name;
                }
            });
        }
        return provinceSelected;
    }

    const getCitySelected = () => {
        var cityLoadedSelected = undefined;
        if(restaurant.address && restaurant.address.country && places && places[restaurant.address.country]) {
            places[restaurant.address.country]['provinces'].forEach(province => {
                if(province && province.name && province.name === restaurant.address.province && province.cities) {
                    province.cities.forEach(city => {
                        if(city && city.name && city.name === restaurant.address.city) {
                            cityLoadedSelected = city.name;
                        }
                    });
                }
            });
        }
        return cityLoadedSelected;
    }

    const getCityByName = (cityToCompare, provinceToCompare, countryToCompare) => {
        var cityLoadedSelected = undefined;
        if(places && places[countryToCompare]) {
            places[countryToCompare]['provinces'].forEach(province => {
                if(province && province.name && province.name === provinceToCompare && province.cities) {
                    province.cities.forEach(city => {
                        if(city && city.name && city.name === cityToCompare) {
                            cityLoadedSelected = city;
                        }
                    });
                }
            });
        }
        return cityLoadedSelected;
    }

    const getRangePriceKey = () => {
        var range = [];
        if(restaurant.price) {
            for(var key in rangePrice) {
                if(rangePrice[key]) {
                    if(key === restaurant.price) {
                        range.push(key);
                        break;
                    }
                }
            }
        }
        return range;
    }

    const selectCountry = value => {
        form.setFieldsValue({
            field_province: undefined,
            field_city: undefined,
            field_postalCode: undefined,
            field_hitos: [],
            field_neighborhood: undefined
        })
        onCountrySelected(value)
    }

    const selectProvince = value => {
        form.setFieldsValue({
            field_city: undefined,
            field_postalCode: undefined,
            field_hitos: [],
            field_neighborhood: undefined
        })
        onProvinceSelected(value)
    }

    const selectCity = value => {
        if(restaurant && restaurant.address && restaurant.address.city === value && restaurant.address.province === provinceSelected && restaurant.address.country === countrySelected) {
            form.setFieldsValue({
                field_postalCode: restaurant.address.postalCodeV2 ? restaurant.address.postalCodeV2 : undefined,
                field_hitos: restaurant.address.hitos? restaurant.address.hitos : [],
                field_neighborhood: restaurant.address.neighborhood ? restaurant.address.neighborhood : undefined,
                field_full_address: undefined
            })
        } else {
            var cityLoaded = getCityByName(value, provinceSelected, countrySelected)
            if(cityLoaded) {
                form.setFieldsValue({
                    field_postalCode: cityLoaded["postalCode"] ? cityLoaded["postalCode"] : undefined,
                    field_hitos: [],
                    field_neighborhood: undefined,
                    field_full_address: undefined
                })
            }
        }
        onCitySelected(value)
    }

    return (
        <Grid>
            <Form onFinish={onSubmit} form={form} initialValues={{
                name: restaurant.name !== undefined ? restaurant.name : "",
                phone: restaurant.phone !== undefined ? restaurant.phone.slice(3) : "",
                field_facebook: restaurant.facebook !== undefined ? restaurant.facebook : "",
                field_instagram: restaurant.instagram !== undefined ? restaurant.instagram : "",
                field_web: restaurant.website !== undefined ? restaurant.website : "",
                field_repartiendo: restaurant.repartiendoDeepLink !== undefined ? restaurant.repartiendoDeepLink : "",
                field_country: getCountrySelected(),
                field_province: getProvinceSelected(),
                field_city: getCitySelected(),
                field_neighborhood: (restaurant.address !== undefined && restaurant.address.neighborhood !== undefined && restaurant.address.neighborhood !== "") ? restaurant.address.neighborhood : undefined,
                field_near_cities: (restaurant.nearCities !== undefined) ? Object.keys(restaurant.nearCities) : undefined,
                field_street: (restaurant.address !== undefined && restaurant.address.street !== undefined) ? restaurant.address.street : "",
                field_postalCode: (restaurant.address !== undefined && restaurant.address.postalCodeV2 !== undefined) ? restaurant.address.postalCodeV2 : (citySelected && citySelected["postalCode"]) ? citySelected["postalCode"] : undefined,
                field_lat: restaurant.l !== undefined ? restaurant.l[0] : "",
                field_lng: restaurant.l !== undefined ? restaurant.l[1] : "",
                field_range_price: getRangePriceKey(),
                field_hitos: (restaurant.address !== undefined && restaurant.address.hitos !== undefined) ? restaurant.address.hitos : [],
                field_styles: restaurant.styles !== undefined ? restaurant.styles : [],
                field_types: restaurant.types !== undefined ? restaurant.types : [],
                field_services: restaurant.services !== undefined ? restaurant.services : [],
                field_accessPeopleWithDisabilities: restaurant.accessPeopleWithDisabilities !== undefined ? restaurant.accessPeopleWithDisabilities : true,
                field_advertising: restaurant.advertising !== undefined ? restaurant.advertising : false,
                prefix: '54'
            }}>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Nombre" name="name" rules={[{ required: true, message: 'Por favor, complete el nombre del restaurante', }]}>
                            <Input placeholder="Nombre del restaurante" />
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Teléfono" name="phone" rules={[{ required: true, message: 'Por favor, complete el número de teléfono del restaurante', }]}>
                            <Input type="number" addonBefore={
                                <Form.Item name="prefix">
                                    <Select style={{ width: 70, height: "auto" }}>
                                        <Option value="54" key="54">+54</Option>
                                    </Select>
                                </Form.Item>} placeholder="Teléfono"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Sitios</Divider>
                <Row>
                    <Col xs={12} sm={12} md={6}>
                        <Form.Item label="Facebook" name="field_facebook" rules={[{ required: false }]}>
                            <Input addonBefore={<FacebookOutlined />} placeholder="Link de facebook"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                        <Form.Item label="Instagram" name="field_instagram" rules={[{ required: false }]}>
                            <Input addonBefore={<InstagramOutlined />} placeholder="Link de instagram"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={6}>
                        <Form.Item label="Web" name="field_web" rules={[{ required: false }]}>
                            <Input addonBefore={<ChromeOutlined />} placeholder="Link de la web"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                        <Form.Item label="Repartiendo" name="field_repartiendo" rules={[{ required: false }]}>
                            <Input addonBefore={<ShoppingCartOutlined />} placeholder="Deeplink de Repartiendo"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Dirección</Divider>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Item label="País" name="field_country" rules={[{ required: true, message: 'Por favor, seleccione un país' }]}>
                            <Select defaultActiveFirstOption={true} onSelect={selectCountry}
                                placeholder="País">
                                {
                                    countriesOptions && countriesOptions.map(key => <Option key={key} value={key}>{key}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Provincia" name="field_province" rules={[{ required: true, message: 'Por favor, seleccione una provincia' }]}>
                            <Select onSelect={selectProvince}
                                placeholder="Provincia">
                                {
                                    provincesOptions && provincesOptions.map(key => <Option key={key} value={key}>{key}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Ciudad" name="field_city" rules={[{ required: true, message: 'Por favor, seleccione una ciudad' }]}>
                            <Select onSelect={selectCity}
                                placeholder="Ciudad">
                                {
                                    citiesOptions && citiesOptions.map(key => <Option key={key} value={key}>{key}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Barrio" name="field_neighborhood" rules={[{ required: false, message: 'Por favor, seleccione un barrio' }]}>
                            <Select placeholder="Barrio">
                                <Option key={"EMPTY"} value={null}>{"Ninguno"}</Option>
                                {
                                    (citySelected && citySelected["neighborhoods"]) && citySelected["neighborhoods"].map(neighborhood => <Option key={neighborhood.name} value={neighborhood.name}>{neighborhood.name}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item label={<span>Ciudades de cercanía &nbsp; &nbsp; <Tooltip title="Los usuarios podrán hacer reservas en todas las ciudades de cercanía que seleccione"><QuestionCircleOutlined /></Tooltip></span>} name="field_near_cities" rules={[]}>
                            <TreeSelect 
                                showSearch
                                style={{ width: '80%' }}
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                placeholder="Seleccione las ciudades de cercanía"
                                allowClear
                                multiple>
                                    {
                                        places && Object.keys(places).map(place => {
                                        return(
                                            <TreeNode value={place} title={place} key={place} selectable={false}>
                                            {
                                                places[place].provinces && Object.keys(places[place].provinces).map(province => (
                                                    <TreeNode value={`${place}_${places[place].provinces[province].name}`} title={`${places[place].provinces[province].name}`} key={`${place}_${places[place].provinces[province].name}`} selectable={false}>
                                                        {
                                                            places[place].provinces[province].cities && Object.keys(places[place].provinces[province].cities).map(city => {
                                                                if(citySelected === null || citySelected.name !== places[place].provinces[province].cities[city].name) {
                                                                    return(<TreeNode value={`${place}_${places[place].provinces[province].name}_${places[place].provinces[province].cities[city].name}`} title={`${places[place].provinces[province].cities[city].name}`} key={`${place}_${places[place].provinces[province].name}_${places[place].provinces[province].cities[city].name}`}>
                                                                    </TreeNode>)
                                                                } else {
                                                                    return(<TreeNode value={`${place}_${places[place].provinces[province].name}_${places[place].provinces[province].cities[city].name}`} title={`${places[place].provinces[province].cities[city].name}`} key={`${place}_${places[place].provinces[province].name}_${places[place].provinces[province].cities[city].name}`} disabled>
                                                                    </TreeNode>)
                                                                }
                                                            })
                                                        }
                                                    </TreeNode>
                                                ))
                                            }
                                            </TreeNode>
                                        )
                                        })
                                    }
                                </TreeSelect>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Dirección" name="field_street" rules={[{ required: true, message: 'Por favor, complete la dirección del restaurante' }]}>
                            <Input placeholder="Dirección"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Código postal" name="field_postalCode" rules={[{ required: true, message: 'Por favor, complete el código postal de la ciudad' }]}>
                            <Input placeholder="Código postal"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Latitud" name="field_lat" rules={[{ required: true, message: 'Por favor, complete la latitud del restaurante' }]}>
                            <Input placeholder="Longitud" onChange={onLatChange}/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Longitud" name="field_lng" rules={[{ required: true, message: 'Por favor, complete la longitud del restaurante' }]}>
                            <Input placeholder="Latitud" onChange={onLngChange}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} style={{height: '400px', width: '100%'}}>
                        <Form.Item>
                            <LocationMap lat={lat} lng={lng}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Rango de precio del cubierto</Divider>
                <Row>
                    <Col xs={12}>
                        <Form.Item name="field_range_price" rules={[{ required: true, message: 'Por favor, seleccione un rango' }]}>
                            <Select placeholder="Rango">
                                {
                                    rangePrice && Object.keys(rangePrice).map(key => <Option key={key} value={key}>{rangePrice[key]}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">Hitos geográficos</Divider>
                <Row>
                    <Col xs={12}>
                        <Form.Item label="Hitos" name="field_hitos" rules={[{ required: false, message: 'Por favor, seleccione al menos un hito' },
                                {
                                    validator: (rule, value, callback) => {
                                      if (value) {
                                        if (value.length > 4) {
                                          callback("El máximo es de 4 hitos");
                                        } else if (value.length <= 4) {
                                          callback();
                                        }
                                      }
                                      return;
                                    }
                                }]}>
                            <Select
                                mode="multiple"
                                placeholder="Seleccione como máximo 4 hitos">
                                {
                                    (citySelected && citySelected["hitos"]) && citySelected["hitos"].map(hito => <Option key={hito.name} value={hito.name}>{hito.name}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider></Divider>
                <Row>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Estilos" name="field_styles" rules={[{ required: true, message: 'Por favor, seleccione al menos un estilo' },
                                {
                                    validator: (rule, value, callback) => {
                                      if (value) {
                                        if (value.length > 4) {
                                          callback("El máximo es de 4 estilos");
                                        } else if (value.length <= 4) {
                                          callback();
                                        }
                                      }
                                      return;
                                    }
                                }]}>
                            <Select
                                mode="multiple"
                                placeholder="Seleccione como máximo 4 estilos">
                                {
                                    styles && Object.values(styles).map(style => <Option key={style} value={style}>{style}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6}>
                        <Form.Item label="Tipos de comida" name="field_types" rules={[{ required: true, message: 'Por favor, seleccione al menos un tipo' },
                                {
                                    validator: (rule, value, callback) => {
                                      if (value) {
                                        if (value.length > 50) {
                                          callback("El máximo es de 50 tipos");
                                        } else if (value.length <= 50) {
                                          callback();
                                        }
                                      }
                                      return;
                                    }
                                }]}>
                            <Select
                                mode="multiple"
                                placeholder="Seleccione como máximo 6 tipos">
                                {
                                    types && Object.values(types).map(type => <Option key={type} value={type}>{type}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Form.Item label="Servicios" name="field_services" rules={[{ required: true, message: 'Por favor, seleccione al menos un servicio' },
                                {
                                    validator: (rule, value, callback) => {
                                      if (value) {
                                        if (value.length > 6) {
                                          callback("El máximo es de 6 servicios");
                                        } else if (value.length <= 6) {
                                          callback();
                                        }
                                      }
                                      return;
                                    }
                                }]}>
                            <Select
                                mode="multiple"
                                placeholder="Seleccione como máximo 6 servicios">
                                {
                                    services && Object.values(services).map(service => <Option key={service} value={service}>{service}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider></Divider>
                <Row center="sm">
                    <Col xs={12} sm={12} md={6}>
                        <Row center="xs" start="md">
                            <Col xs={12} sm={12} md={12}>
                                <Form.Item name="field_accessPeopleWithDisabilities" valuePropName="checked">
                                    <Checkbox>
                                        Acceso para personas con discapacidad
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                        <Row center="xs" end="md">
                            <Col xs={12} sm={12} md={12}>
                                <Form.Item name="field_advertising" valuePropName="checked">
                                    <Checkbox disabled={true}>
                                        Restaurante sólo para publicidad
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider></Divider>
                <Row>
                    <Col xs={12} sm={5} md={4}>
                        <Row center="xs" start="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        isSaving ?
                                            <Button type="primary" htmlType="submit" disabled={true} loading>
                                                Guardando
                                            </Button>
                                            :
                                            <Button type="primary" htmlType="submit">
                                                Guardar
                                            </Button>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={2} md={4}></Col>
                    <Col xs={12} sm={5} md={4}>
                        <Row center="xs" end="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        <Button disabled={isSaving} onClick={onExit}>
                                            Cancelar
                                        </Button>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Grid>
    );
};

FormProfileResto.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isSaving: PropTypes.bool.isRequired,
};

export default FormProfileResto;